import { PDFDocument } from "pdf-lib";

export async function pdfMerger(...files: Blob[]) {
    const newPDF = await PDFDocument.create();

    await Promise.all(
        files.map(async (file) => {
            const arrayBuffer = await file.arrayBuffer();

            if (file.type === "application/pdf") {
                const pdf = await PDFDocument.load(arrayBuffer);
                const pages = await newPDF.copyPages(pdf, pdf.getPageIndices());
                await Promise.all(pages.map((page) => newPDF.addPage(page)));
            } else if (file.type === "image/jpeg") {
                const image = await newPDF.embedJpg(arrayBuffer);
                const page = newPDF.addPage([image.width, image.height]);
                page.drawImage(image);
            }
        })
    );

    const b64 = await newPDF.saveAsBase64();
    return fetch(`data:application/pdf;base64,${b64}`).then((res) =>
        res.blob()
    );
}
